// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assing-agncy {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #C7C7C7;
  padding: 4px;
}

.gc-agency-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

p.gc-agency-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.gc-agency-img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gc-agency-img img {
  min-width: 100%;
}

.icon-badge-gold:before {
  content: "\\e900";
  color: #f2c94c;
}

.gc-pr-12 {
  padding-right: 12px !important;
}

.gc-pl-12 {
  padding-left: 12px !important;
}

.custom-invalid {
  border: 1px solid red !important;
}

.validation-text {
  display: block;
  margin-top: 5px;
  color: red;
}

.max-img-note {
  font-size: 12px;
  margin: 8px 0 20px 0;
}

.table-header > div:first-child {
  flex: 1 1 0;
  min-width: min-content;
}
.table-header > div:first-child .user-label {
  min-width: max-content;
}
.table-header h2 {
  line-height: 1;
}
.table-header .table-search-wrapper {
  max-width: 452px;
  flex: 1 1 auto;
  margin: 0;
}
.table-header .table-calendar-wrapper,
.table-header .field,
.table-header .export-btn,
.table-header p-button {
  margin: 0;
}
.table-header .field {
  margin-bottom: 0 !important;
}
@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    max-width: 100%;
    width: 100%;
  }
}

::ng-deep .app-link-dropdown.p-dropdown {
  display: flex !important;
  align-items: center !important;
}
::ng-deep .app-link-dropdown.p-dropdown .p-dropdown-label {
  display: flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  line-height: normal !important;
  height: 100% !important;
}

.export-button {
  pointer-events: none;
}

.export-report {
  position: relative;
  display: inline-block;
}
.export-report .p-button {
  position: relative;
  z-index: 2;
  pointer-events: none;
}
.export-report .p-dropdown {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
}
.export-report .p-dropdown .p-dropdown-label {
  color: transparent !important;
  -webkit-user-select: none;
          user-select: none;
  visibility: hidden !important;
  opacity: 0 !important;
  text-indent: -9999px;
}
.export-report .p-dropdown::before {
  content: "Generate Reports";
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  pointer-events: none;
  color: #495057;
  font-size: 14px;
  font-weight: 500;
  z-index: 4;
  white-space: nowrap;
  display: block;
  visibility: visible;
  opacity: 1;
}
.export-report .p-dropdown.p-disabled::before {
  color: #6c757d;
  opacity: 0.6;
}
.export-report .p-dropdown.p-focus::before {
  color: #007bff;
}
.export-report .p-dropdown:hover::before {
  color: #495057;
}
.export-report .p-dropdown .p-dropdown-trigger {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}
.export-report .p-dropdown .p-dropdown-items-wrapper .p-dropdown-label,
.export-report .p-dropdown .p-dropdown-item .p-dropdown-label {
  display: none !important;
}
@media (prefers-contrast: high) {
  .export-report .p-dropdown::before {
    color: ButtonText;
  }
  .export-report .p-dropdown.p-disabled::before {
    color: GrayText;
  }
}
@media (prefers-reduced-motion: reduce) {
  .export-report .p-dropdown {
    transition: none !important;
  }
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-label {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-trigger {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

:host ::ng-deep .export-report .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

:host ::ng-deep .p-checkbox-label {
  margin-left: 0.5rem;
}

.agency-level-preview {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.agency-level-preview img {
  height: 28px;
  width: auto;
  display: inline-block;
}

.agency-level-badge-icon {
  height: 20px;
  width: auto;
  margin-right: 0.5rem;
  vertical-align: middle;
}

.dropzone {
  position: relative;
  height: 200px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.dropzone .textLink {
  color: #1F2937 !important;
}
.dropzone .textLink u {
  text-decoration: underline;
  margin-left: 4px;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fileupload-text {
  display: block;
  width: 85%;
  word-wrap: break-word;
}

.fileupload-meta {
  display: flex;
  flex-direction: column;
}

.fileupload-uploaded-at {
  color: #6b7280;
  font-size: 12px;
  margin-top: 4px;
}

.ph-settings-attempts-row {
  margin-top: 1rem;
}

.template-settings-section {
  margin-top: 0.75rem;
  padding-top: 0;
  border-top: none;
}
.template-settings-section .template-group {
  margin-bottom: 1rem;
}
.template-settings-section .template-group:last-child {
  margin-bottom: 0;
}
.template-settings-section .template-label-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
}
.template-settings-section .template-field-label {
  font-weight: 600;
  font-size: 14px;
  color: #2d388b;
  margin: 0 0 4px 0;
  display: block;
  line-height: 1.3;
}
.template-settings-section .template-label-row .template-field-label {
  margin-bottom: 0;
}
.template-settings-section .template-sms-block .template-field-label {
  margin-top: 0;
  margin-bottom: 4px;
}
.template-settings-section .template-info-icon {
  color: #9ca3af;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
}
.template-settings-section .template-info-icon:hover {
  color: #2d388b;
}
.template-settings-section .template-description {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
  margin: 4px 0 6px 0;
  line-height: 1.35;
}
.template-settings-section .template-description .template-desc-icon {
  color: #9ca3af;
  font-size: 12px;
  margin-top: 1px;
  flex-shrink: 0;
}
.template-settings-section .template-sms-block {
  margin-top: 8px;
}
.template-settings-section .template-field-grid {
  margin-top: 0;
  margin-bottom: 0;
}

:host ::ng-deep .template-settings-section .template-textarea {
  resize: vertical !important;
  min-height: 96px;
  width: 100%;
}
:host ::ng-deep .template-settings-section .template-textarea-sms {
  min-height: 56px;
}

::ng-deep .template-tooltip {
  max-width: 350px;
  white-space: normal;
  word-wrap: break-word;
}

.delivery-action {
  min-width: 7rem;
  justify-content: center;
}

.delivery-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.delivery-value {
  overflow-wrap: anywhere;
}`, "",{"version":3,"sources":["webpack://./src/app/agencies/agencies.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qFAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AAEF;;AAAA;EACI,oBAAA;EACA,eAAA;EACA,YAAA;AAGJ;;AADA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAIJ;AAHI;EACE,eAAA;AAKN;;AADA;EACE,gBAAA;EACA,cAAA;AAIF;;AAFA;EACE,8BAAA;AAKF;;AAHA;EACE,6BAAA;AAMF;;AAJA;EACE,gCAAA;AAOF;;AALA;EACE,cAAA;EACA,eAAA;EACA,UAAA;AAQF;;AANA;EACE,eAAA;EACA,oBAAA;AASF;;AAJE;EACE,WAAA;EACA,sBAAA;AAOJ;AANI;EACE,sBAAA;AAQN;AAJE;EACE,cAAA;AAMJ;AAHE;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AAKJ;AAFE;;;;EAIE,SAAA;AAIJ;AADE;EACE,2BAAA;AAGJ;AAAE;EA/BF;IAgCI,eAAA;IACA,2BAAA;EAGF;EAFE;IACE,eAAA;IACA,WAAA;EAIJ;AACF;;AACA;EACE,wBAAA;EACA,8BAAA;AAEF;AAAE;EACE,wBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8BAAA;EACA,uBAAA;AAEJ;;AACA;EACE,oBAAA;AAEF;;AACA;EACE,kBAAA;EACA,qBAAA;AAEF;AAAE;EAEE,kBAAA;EACA,UAAA;EACA,oBAAA;AACJ;AAEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAAJ;AAGI;EACE,6BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,qBAAA;EACA,oBAAA;AADN;AAKI;EACE,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AAHN;AAOI;EACE,cAAA;EACA,YAAA;AALN;AASI;EACE,cAAA;AAPN;AAWI;EACE,cAAA;AATN;AAaI;EACE,wBAAA;EACA,6BAAA;EACA,qBAAA;AAXN;AAiBM;;EACE,wBAAA;AAdR;AAoBE;EACE;IACE,iBAAA;EAlBJ;EAqBE;IACE,eAAA;EAnBJ;AACF;AAuBE;EACE;IACE,2BAAA;EArBJ;AACF;;AA0BA;EACE,wBAAA;EACA,6BAAA;EACA,qBAAA;AAvBF;;AA0BA;EACE,wBAAA;EACA,6BAAA;EACA,qBAAA;AAvBF;;AA6BI;EACE,yBAAA;EACA,8BAAA;EACA,qBAAA;AA1BN;;AA+BA;EAEE,mBAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,qBAAA;AA7BF;AA+BE;EACE,YAAA;EACA,WAAA;EACA,qBAAA;AA7BJ;;AAiCA;EACE,YAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA9BF;AAgCE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;AA9BJ;AAiCE;EACE,yBAAA;AA/BJ;AAiCI;EACE,0BAAA;EACA,gBAAA;AA/BN;;AAoCA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,UAAA;EACA,qBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,sBAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,gBAAA;AAjCF;;AAoCA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAjCF;AAmCE;EACE,mBAAA;AAjCJ;AAmCI;EACE,gBAAA;AAjCN;AAqCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAnCJ;AAsCE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AApCJ;AAuCE;EACE,gBAAA;AArCJ;AAwCE;EACE,aAAA;EACA,kBAAA;AAtCJ;AAyCE;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAvCJ;AAyCI;EACE,cAAA;AAvCN;AA2CE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAzCJ;AA2CI;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAzCN;AA6CE;EACE,eAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,gBAAA;AA5CJ;;AAiDE;EACE,2BAAA;EACA,gBAAA;EACA,WAAA;AA9CJ;AAiDE;EACE,gBAAA;AA/CJ;;AAmDA;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;AAhDF;;AAqDA;EACE,eAAA;EACA,uBAAA;AAlDF;;AAuDA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AApDF;;AAuDA;EACE,uBAAA;AApDF","sourcesContent":[".assing-agncy {\n  height: 54px;\n  border: 1px solid #D1D5DB;\n  border-radius: 6px;\n  padding: 12px 16px;\n  display: flex;\n  .assing-agncy-img{\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #fff url(../../assets/images/agency-icon-blue.svg) no-repeat  center center;\n    background-size: 45%;\n    color: #2d388b;\n    text-align: center;\n    font-size: 25px;\n    font-weight: 600;\n    flex: 0 0 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #C7C7C7;\n    padding: 4px;\n  }\n}\n\n.gc-agency-name{\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #1F2937;\n}\np.gc-agency-handle{\n  font-style: italic;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgb(75 85 99 / 50%);\n}\n.disabled {\n    pointer-events: none;\n    cursor: default;\n    opacity: 0.6;\n  }\n.gc-agency-img{\n    width: 46px;\n    height: 46px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #fff;\n    color: #2d388b;\n    text-align: center;\n    font-size: 25px;\n    font-weight: 600;\n    flex: 0 0 46px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    img{\n      min-width:100%;\n    }\n}\n\n.icon-badge-gold:before {\n  content: \"\\e900\";\n  color: #f2c94c;\n}\n.gc-pr-12{\n  padding-right: 12px !important;\n}\n.gc-pl-12{\n  padding-left: 12px !important;\n}\n.custom-invalid {\n  border: 1px solid red !important;\n}\n.validation-text{\n  display: block;\n  margin-top: 5px;\n  color: red;\n}\n.max-img-note {\n  font-size: 12px;\n  margin: 8px 0 20px 0;\n}\n\n.table-header{\n  // Wrap at the title's narrowest width (as when h2 was min-content) but let it fill the row.\n  > div:first-child {\n    flex: 1 1 0;\n    min-width: min-content;\n    .user-label {\n      min-width: max-content;\n    }\n  }\n\n  h2 {\n    line-height: 1;\n  }\n\n  .table-search-wrapper {\n    max-width: 452px;\n    flex: 1 1 auto;\n    margin: 0;\n  }\n\n  .table-calendar-wrapper,\n  .field,\n  .export-btn,\n  p-button {\n    margin: 0;\n  }\n\n  .field {\n    margin-bottom: 0 !important;\n  }\n\n  @media(max-width:1200px) {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    .table-search-wrapper{\n      max-width: 100%;\n      width: 100%;\n    }\n  }\n}\n\n// App Link Dropdown Styles\n::ng-deep .app-link-dropdown.p-dropdown {\n  display: flex !important;\n  align-items: center !important;\n\n  .p-dropdown-label {\n    display: flex !important;\n    align-items: center !important;\n    padding: 0 12px !important;\n    line-height: normal !important;\n    height: 100% !important;\n  }\n}\n.export-button{\n  pointer-events: none;\n}\n// Export Report Dropdown Label Preservation\n.export-report {\n  position: relative;\n  display: inline-block;\n\n  .p-button {\n    // Ensure the button is visible and maintains its styling\n    position: relative;\n    z-index: 2;\n    pointer-events: none; // Let clicks pass through to dropdown\n  }\n\n  .p-dropdown {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 3;\n\n    // Completely hide the default dropdown label text and selected value\n    .p-dropdown-label {\n      color: transparent !important;\n      user-select: none;\n      visibility: hidden !important;\n      opacity: 0 !important;\n      text-indent: -9999px; // Additional hiding technique\n    }\n\n    // Create overlay with fixed \"Generate Reports\" text that never changes\n    &::before {\n      content: \"Generate Reports\";\n      position: absolute;\n      top: 50%;\n      left: 12px;\n      transform: translateY(-50%);\n      pointer-events: none;\n      color: #495057;\n      font-size: 14px;\n      font-weight: 500;\n      z-index: 4; // Keep this low to not interfere with global components\n      white-space: nowrap;\n      display: block;\n      visibility: visible;\n      opacity: 1;\n    }\n\n    // Disabled state styling for the preserved label\n    &.p-disabled::before {\n      color: #6c757d;\n      opacity: 0.6;\n    }\n\n    // Focus state styling for the preserved label\n    &.p-focus::before {\n      color: #007bff;\n    }\n\n    // Hover state - maintain label stability\n    &:hover::before {\n      color: #495057;\n    }\n\n    // Hide the dropdown trigger (chevron down icon)\n    .p-dropdown-trigger {\n      display: none !important;\n      visibility: hidden !important;\n      opacity: 0 !important;\n    }\n\n    // Additional hiding for any selected item display\n    .p-dropdown-items-wrapper,\n    .p-dropdown-item {\n      .p-dropdown-label {\n        display: none !important;\n      }\n    }\n  }\n\n  // High contrast mode support\n  @media (prefers-contrast: high) {\n    .p-dropdown::before {\n      color: ButtonText;\n    }\n\n    .p-dropdown.p-disabled::before {\n      color: GrayText;\n    }\n  }\n\n  // Reduced motion support\n  @media (prefers-reduced-motion: reduce) {\n    .p-dropdown {\n      transition: none !important;\n    }\n  }\n}\n\n// Scoped global overrides - only target export-report dropdowns specifically\n:host ::ng-deep .export-report .p-dropdown .p-dropdown-label {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n}\n\n:host ::ng-deep .export-report .p-dropdown .p-dropdown-trigger {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n}\n\n// Ensure dropdown panel shows correctly when opened - scoped to export-report only\n:host ::ng-deep .export-report .p-dropdown-panel {\n  .p-dropdown-items {\n    .p-dropdown-item {\n      display: block !important;\n      visibility: visible !important;\n      opacity: 1 !important;\n    }\n  }\n}\n\n:host ::ng-deep .p-checkbox-label\n {\n  margin-left: 0.5rem;\n}\n\n.agency-level-preview {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n\n  img {\n    height: 28px;\n    width: auto;\n    display: inline-block;\n  }\n}\n\n.agency-level-badge-icon {\n  height: 20px;\n  width: auto;\n  margin-right: 0.5rem;\n  vertical-align: middle;\n}\n\n.dropzone {\n  position: relative;\n  height: 200px;\n  width: 100%;\n  border: 2px dashed #D1D5DB;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  .textLink {\n    color: #1F2937 !important;\n\n    u {\n      text-decoration: underline;\n      margin-left: 4px;\n    }\n  }\n}\n\n.fileupload-info {\n  background: #f6f8ff;\n  padding: 15px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.fileupload-text {\n  display: block;\n  width: 85%;\n  word-wrap: break-word;\n}\n\n.fileupload-meta {\n  display: flex;\n  flex-direction: column;\n}\n\n.fileupload-uploaded-at {\n  color: #6b7280;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.ph-settings-attempts-row {\n  margin-top: 1rem;\n}\n\n.template-settings-section {\n  margin-top: 0.75rem;\n  padding-top: 0;\n  border-top: none;\n\n  .template-group {\n    margin-bottom: 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .template-label-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 0;\n  }\n\n  .template-field-label {\n    font-weight: 600;\n    font-size: 14px;\n    color: #2d388b;\n    margin: 0 0 4px 0;\n    display: block;\n    line-height: 1.3;\n  }\n\n  .template-label-row .template-field-label {\n    margin-bottom: 0;\n  }\n\n  .template-sms-block .template-field-label {\n    margin-top: 0;\n    margin-bottom: 4px;\n  }\n\n  .template-info-icon {\n    color: #9ca3af;\n    font-size: 14px;\n    cursor: pointer;\n    flex-shrink: 0;\n\n    &:hover {\n      color: #2d388b;\n    }\n  }\n\n  .template-description {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n    font-size: 12px;\n    color: #6b7280;\n    margin: 4px 0 6px 0;\n    line-height: 1.35;\n\n    .template-desc-icon {\n      color: #9ca3af;\n      font-size: 12px;\n      margin-top: 1px;\n      flex-shrink: 0;\n    }\n  }\n\n  .template-sms-block {\n    margin-top: 8px;\n  }\n\n  .template-field-grid {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n}\n\n:host ::ng-deep .template-settings-section {\n  .template-textarea {\n    resize: vertical !important;\n    min-height: 96px;\n    width: 100%;\n  }\n\n  .template-textarea-sms {\n    min-height: 56px;\n  }\n}\n\n::ng-deep .template-tooltip {\n  max-width: 350px;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\n// Merged Document Delivery slots. The buttons on the right of every row share one width, so Set/Change\n// and Verify form a single aligned column instead of sitting wherever their labels put them.\n.delivery-action {\n  min-width: 7rem;\n  justify-content: center;\n}\n\n// Status pills. The markup asked for bootstrap badge classes this app does not load, so they rendered\n// as bare capitals next to the address.\n.delivery-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.delivery-value {\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
